export const LOAD_RESOLVER_DATA = 'LOAD_RESOLVER_DATA';
